var RETRY_DELAY_MS = 1000;
var MAX_ATTEMPTS = 3;
export var componentLoader = function(lazyComponent) {
    var attemptsLeft = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : MAX_ATTEMPTS;
    return new Promise(function(resolve, reject) {
        lazyComponent().then(resolve).catch(function(error) {
            setTimeout(function() {
                if (attemptsLeft <= 1) {
                    var storageKey = "vch.retry-lazy-".concat(window.btoa(lazyComponent.toString()));
                    var _window_sessionStorage_getItem;
                    var hasRefreshed = JSON.parse((_window_sessionStorage_getItem = window.sessionStorage.getItem(storageKey)) !== null && _window_sessionStorage_getItem !== void 0 ? _window_sessionStorage_getItem : "false");
                    if (!hasRefreshed) {
                        window.sessionStorage.setItem(storageKey, "true");
                        window.location.reload();
                        resolve({
                            default: function() {
                                return null;
                            }
                        });
                    } else {
                        reject(error);
                    }
                } else {
                    componentLoader(lazyComponent, attemptsLeft - 1).then(resolve, reject);
                }
            }, RETRY_DELAY_MS);
        });
    });
};

//# sourceMappingURL=component-loader.js.map